import { $http } from "@/assets/js/appFunc";
import { uid } from "quasar";
import { SMART_CONTRACT_TYPES, SMART_CONTRACT_PLUGIN_IDS } from "@/components/SmartContractDesigner/smartContractPluginIDs";
import { DiagramHasContentCheck } from "@/assets/js/DiagramValidator/DiagramLevelValidators/DiagramHasContentCheck";
import { DiagramUnconnectedPluginsCheck } from "@/assets/js/DiagramValidator/DiagramLevelValidators/DiagramUnconnectedPluginsCheck";
import { SELECTED_PLUGIN_INFORMATION_DATA } from "./const/selectedPluginInformationData";
import { InvalidBlockEnding } from "../../../assets/js/DiagramValidator/DiagramLevelValidators/CodeBlockStartEndCheck";
import { SCLoopMustHaveBodyValidaton } from "../../../assets/js/DiagramValidator/PluginCustomValidators/SCLoopMustHaveBodyValidaton";

export const saveFunctionContract = (store, payload) => {
    if (payload && payload.body) {
        payload.body = payload.body.filter(elem => elem.type !== "GENERAL_END_PLUGIN"
        && elem.type !== "GENERAL_START_PLUGIN" && elem.type !== "SMART_CONTRACT_DELIMITATOR");
    }
    const copyObject = JSON.parse(JSON.stringify(payload));
    if (typeof (copyObject.diagramData) === "object") {
        copyObject.diagramData = JSON.stringify(copyObject.diagramData);
    }

    const req = {
        type: "POST",
        url: "/blockchain/function",
        data: copyObject
    };
    return $http(req, true).then(
        data => data
    );
};

export const getFunctionById = (store, payload) => {
    const id = payload;
    store.commit("setFunctionSelected", []);
    const req = {
        type: "GET",
        url: `/blockchain/function/${id}`
    };
    return $http(req, true).then(
        data => {
            store.commit("setFunctionSelected", data.data);
            return data.data;
        },
        error => {
            console.log(error);
            return error;
        }
    );
};

export const getStaticVariables = (store, payload) => {
    const id = payload;
    const req = {
        type: "GET",
        url: `/blockchain/types/bc/${id}/contract-variables`
    };
    return $http(req, true).then(
        data => {
            store.commit("setStaticVariables", data.data);
            return data.data;
        },
        error => error
    );
};

export const getCurrentContract = (store) => {
    let functionId = null;
    if (store.state.inEditFunction && store.state.inEditFunction.id) {
        functionId = store.state.inEditFunction.id;
    }
    const req = {
        type: "GET",
        url: `/blockchain/type/functionId/${functionId}`
    };

    return $http(req, true).then(
        data => {
            store.commit("setCurrentContract", data.data);
            return data.data;
        },
        error => {
            console.log(error);
            return error;
        }
    );
};
export const getFunctionsForApp = (store) => {
    const currentApp = store.rootGetters["apps/currentApp"];

    store.commit("setApplicationFunctions", []);
    const req = {
        type: "GET",
        url: `/blockchain/${currentApp.blockchainType}/${currentApp.id}/functions`
    };
    return $http(req, true).then(
        data => {
            store.commit("setApplicationFunctions", data.data);
            return data.data;
        },
        error => {
            console.log(error);
            return error;
        }
    );
};

export const getSmartContractPage = (store, page) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/blockchain/smart-contract/${applicationId}/${page}`
    };
    return $http(params, true).then((data) => {
        store.commit("setSmartContractList", data.data);
        return data.data;
    });
};

export const getSCNumber = (context) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/blockchain/smart-contract/${applicationId}/count`

    };
    $http(params, true).then((data) => {
        context.commit("setNumberOfSc", data.data);
    });
};

export const deleteApplicationFunction = (context, functionId) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const req = {
        type: "DELETE",
        url: `/blockchain/function/${functionId}/${applicationId}`
    };
    return $http(req, true).then((data) => data, (err) => err);
};

export const getNewFunctionModel = (store, data) => {
    let dataToReturn = {};
    if (data.selectedTab === "functions") {
        const objectDiagram = {
            connectors: [],
            content: [],
            gridView: {
                padding: 500, cellWidth: 100, cellHeight: 100, rows: 12, cols: 10
            }, //  o sa se puna in momentul in care o sa se adauge si partea de diagrama
            worldData: { width: 2000, height: 2200 }
        };
        dataToReturn = {
            body: [],
            id: data.newData.id,
            contractId: data.contract.id,
            applicationId: data.contract.applicationId,
            description: data.newData.description,
            bcType: data.contract.bcType.type,
            name: data.newData.name,
            functionTypeEnum: "FUNCTION",
            inParameters: data.newData.inParameters,
            outParameters: data.newData.outParameters,
            diagramData: JSON.stringify(objectDiagram),
            functionTypeDto: { id: data.newData.functionTypeDto.id }
        };
    } else if (data.selectedTab === "events") {
        dataToReturn = {
            id: data.newData.id,
            contractId: data.contract.id,
            applicationId: data.contract.applicationId,
            description: data.newData.description,
            bcType: data.contract.bcType.type,
            subscribed: data.newData.subscribed ? data.newData.subscribed : false,
            name: data.newData.name,
            functionTypeEnum: "EVENT",
            inParameters: data.newData.inParameters
        };
    }
    return dataToReturn;
};
export const getFunctionsSignatures = (store) => {
    const currentApp = store.rootGetters["apps/currentApp"];
    const req = {
        type: "GET",
        url: `/blockchain/${currentApp.blockchainType}/${currentApp.id}/functions/signature`
    };

    return $http(req, true).then((data) => {
        store.commit("setFunctionsSignatures", data.data);
    }, (err) => err);
};

export const getNewVariableModel = () => ({
    id: uid(),
    description: null,
    isArray: false,
    index: null,
    name: null,
    type: null,
    isInput: null
});

export const getFunctionData = (store, id) => {
    // TODO: Set call when linking backend
    const index = store.state.applicationFunctions.findIndex(func => func.id === id);
    const { diagramData } = store.state.applicationFunctions[index];
    store.commit("setDiagramData", diagramData);
    return {
        diagram: diagramData
    };
};

export const getSelectedFunctionPreviewCode = (store, func) => {
    const funcToSend = { ...func };
    funcToSend.diagramData = typeof funcToSend.diagramData === "object" ? JSON.stringify(funcToSend.diagramData) : funcToSend.diagramData;
    const req = {
        type: "POST",
        url: `/blockchain/${func.bcType}/function/preview`,
        data: {
            function: funcToSend,
            applicationName: func.name
        }
    };
    return $http(req, true).then((data) => data, (err) => err);
};

export const createSmartContractValidationModel = (store) => {
    const validators = {};
    validators.plugins = SELECTED_PLUGIN_INFORMATION_DATA.reduce((acumulator, value) => {
        if (value.validations) {
            acumulator[value.id] = { ...value.validations };
            if (value.id === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DO_WHILE
                || value.id === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_WHILE
                || value.id === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FOR
                || value.id === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_IF) {
                acumulator[value.id].custom = [SCLoopMustHaveBodyValidaton];
            }
        }
        return acumulator;
    }, {});
    validators.connectors = {};
    validators.connectors[SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN] = [SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN];
    validators.overall = [
        DiagramHasContentCheck,
        DiagramUnconnectedPluginsCheck,
        InvalidBlockEnding
    ];
    store.commit("setSmartContractValidationModel", validators);
};

export const downloadSmartContract = (context, item) => {
    const applicationVersionId = context.rootGetters["apps/currentApp"].versionId;
    const params = {
        type: "POST",
        url: `/blockchain/smart-contract/${item.id}/${applicationVersionId}/download`,
        data: {},
        responseType: "arraybuffer"
    };
    return $http(params, true).then(
        data => {
            const url = window.URL.createObjectURL(new Blob([data.data], { type: "application/octet-stream" }));
            const link = document.createElement("a");
            const filename = data.headers["content-disposition"].split("=")[1];
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
        },
        error => error
    );
};

export const downloadSwagger = (context) => {
    const processDefinitionId = context.rootGetters["main/getCurrentProcessId"];
    const { processInformation, swaggerId } = context.rootGetters["apps/currentProcess"];
    let fileUUID = "";
    if (processInformation) {
        fileUUID = processInformation.swagger_uuid;
    }
    if (!fileUUID) {
        fileUUID = swaggerId;
    }
    const params = {
        type: "GET",
        url: `/engine/api/swaggerDescriptor/download/${processDefinitionId}/${fileUUID}`,
        data: {},
        responseType: "arraybuffer"
    };
    return $http(params, true).then(
        data => {
            const url = window.URL.createObjectURL(new Blob([data.data], { type: "application/octet-stream" }));
            const link = document.createElement("a");
            const filename = data.headers["content-disposition"].split("=")[1];
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
        },
        error => error
    );
};

export const getSmartContractCode = (context, item) => {
    const applicationVersionId = context.rootGetters["apps/currentApp"].versionId;
    const params = {
        type: "GET",
        url: `/blockchain/smart-contract/${item.id}/${applicationVersionId}/preview`,
        data: {}
    };
    return $http(params, true).then((data) => data, (err) => err);
};

export const deleteSmartContract = (context, item) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "DELETE",
        url: `/blockchain/smart-contract/${item.id}/${applicationId}`,
        data: {}
    };
    return $http(params, true).then((data) => data, (err) => err);
};

export const getScTypes = (context) => {
    const params = {
        type: "GET",
        url: "/blockchain/types"
    };
    return $http(params, true).then(data => {
        context.commit("setScTypes", data.data);
        return data.data;
    },
    err => err);
};

export const getScCredentials = (context, bcTypeId) => {
    const params = {
        type: "GET",
        url: `/blockchain/credentials/${bcTypeId}`
    };
    return $http(params, true).then(data => {
        context.commit("setScCredentials", data.data);
    },
    err => err);
};

export const getScNetworks = (context, bcTypeId) => {
    const params = {
        type: "GET",
        url: `/blockchain/network/${bcTypeId}`
    };
    return $http(params, true).then(data => {
        context.commit("setScNetworks", data.data);
    },
    err => err);
};

export const saveSmartContract = (context, scObject) => {
    // ramane pana o sa se faca noua functionalitate pe edit smartContract
    let postObject = {};
    if (scObject && scObject.network) {
        postObject = {
            id: scObject.id || null,
            name: scObject.name,
            description: scObject.description,
            bcTypeId: scObject.type,
            credentialsId: scObject.credentials,
            networkId: scObject.network,
            address: scObject.address,
            applicationId: context.rootGetters["main/getCurrentApplicationId"]
        };
    } else {
        postObject = scObject;
    }
    const params = {
        type: "POST",
        url: "/blockchain/smart-contract/save",
        data: postObject
    };
    return $http(params, true).then(data => data,
        error => error);
};

export const importSmartContract = (context, importObject) => {
    const params = {
        type: "POST",
        url: "/blockchain/smart-contract/parseAbi",
        data: importObject
    };
    return $http(params, true).then(data => data,
        error => error);
};

export const getContractsSameNetwork = (context) => {
    const smartContractId = context.state.inEditFunction.contractId;
    const functionId = context.state.inEditFunction.id;
    const params = {
        type: "GET",
        url: `/blockchain/smart-contract/${smartContractId}/contracts/${functionId}`,
        data: {}

    };
    return $http(params, true).then(data => {
        context.commit("setScSameNetwork", data.data);
        return data.data;
    },
    error => error);
};

export const getEvents = (context) => {
    const smartContractId = context.state.inEditFunction.contractId;
    const params = {
        type: "GET",
        url: `/blockchain/smart-contract/${smartContractId}/events`,
        data: {}

    };
    return $http(params, true).then(data => {
        context.commit("setEvent", data.data);
        return data.data;
    },
    error => error);
};

export const getTemplateSC = (context) => {
    const page = 0;
    const params = {
        type: "GET",
        url: `/blockchain/templates/${page}`,
        data: {}

    };
    return $http(params, true).then(data => {
        context.commit("setTemplate", data.data);
        return data.data;
    },
    error => error);
};

export const getContract = (context, smartContractId) => {
    const params = {
        type: "GET",
        url: `/blockchain/smart-contract/${smartContractId}`
    };
    return $http(params, true).then(data => data.data,
        error => error);
};
